<template lang="pug">
  vm-prompt(:vm-buttons-hidden="true" vm-size="small" @vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalViewsClaimVisible" vm-title='Claims views' :vm-is-valid="!$v.detail.$invalid")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        vm-table(v-model="selected" max-height="350px" :data="claimsSeed")
          template(slot="header")
            .d-flex.justify-content-between
              div
              div
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsClaims") {{ $t('strings.' + column) }}
            vm-th
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsClaims")
                slot(v-if="column == 'name'") {{ data[indextr]['user']['name'] }}
                slot(v-if="column == 'date'") {{ data[indextr]['created_at'] | moment('YYYY/MM/DD') }}
</template>
<script>
import moment from 'moment'
import { required, maxLength } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalViewsClaim',
  props: {
    detail: {
      type: Object
    },
    index: {
      type: Number
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    detail: {
      date: {
        required
      },
      question: {
        required,
        maxLength: maxLength(300)
      },
      answer: {
        maxLength: maxLength(300)
      }
    }
  },
  data: () => ({
    columnsClaims: [
      'name',
      'date'
    ]
  }),
  watch: {
    isModalViewsClaimVisible (flag) {
      if (flag) {
        this.loadClamSeenBy({ id: this.detail.id })
      }
    }
  },
  computed: {
    ...mapGetters([
      'claimsSeed',
      'isModalViewsClaimVisible'
    ])
  },
  methods: {
    ...mapActions([
      'loadClamSeenBy',
      'setModalViewsClaimVisible',
      'setClamSeenBy'
    ]),
    saveRecord () {
      this.detail.date = moment(this.detail.date, '').format('YYYY-MM-DD')
      this.editShipmentClaim(this.detail).then(() => {
        this.close()
      })
    },
    close () {
      this.setModalViewsClaimVisible(false)
    }
  }
}
</script>
